module.exports = __webpack_public_path__ + "static/media/phone_icon.17e12ce1.svg";